/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface EmailTrackingRef
 */
export interface EmailTrackingRefOptional {
  /**
   *
   * @type {number}
   * @memberof EmailTrackingRef
   */
  emailId?: number;
}

export interface EmailTrackingRef extends EmailTrackingRefOptional {
  /**
   *
   * @type {number}
   * @memberof EmailTrackingRef
   */
  emailId: number;
}

export interface EmailTrackingRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof EmailTrackingRef
   */
  emailId?: number;
  emailIdIsSet: boolean;
}

transformDatesMap.set(
  "EmailTrackingRef",
  function (model: EmailTrackingRef) {},
);

export type EmailTrackingRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  emailId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var EmailTrackingRefMeta: EmailTrackingRefMetaI =
  {} as EmailTrackingRefMetaI;
EmailTrackingRefMeta = typeMeta("EmailTrackingRef", {
  emailId: propertyMeta("emailId", false, true, true, MetaTypesBase.number),
});

const metaI = EmailTrackingRefMeta;

registerMeta(() => {});

export class EmailTrackingRefTracked implements EmailTrackingRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  emailId__I?: number = undefined;

  get emailIdIsSet() {
    return this.emailId !== undefined;
  }
  set emailIdIsSet(v: boolean) {}
  set emailId(v: undefined | number) {
    if (v !== undefined) {
      this.emailId__I = v;
      this.emailIdIsSet = true;
    } else {
      this.emailId__I = v || undefined;
      this.emailIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get emailId() {
    return this.emailId__I;
  }
  constructor(config?: EmailTrackingRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.emailIdIsSet == true && other?.emailIdIsSet == true)
      return this.emailId == other.emailId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.emailId) {
      this.emailIdIsSet = true;
    }
  }
  assignFrom(
    config: EmailTrackingRefOptional,
    options?: AssignOptions,
  ): EmailTrackingRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.emailId && this.emailIdApplyFilter(optionsRequired.filter)) {
      this.emailId = config.emailId;
      if (optionsRequired.unassign) this.emailIdIsSet = false;
      else this.emailIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): EmailTrackingRefTrackedI {
    const cloned = {} as EmailTrackingRefTrackedI;
    if (
      this.emailIdIsSetDeep() &&
      this.emailIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIdIsSet = true;
      cloned.emailId = this.emailId;
    } else {
      //cloned.emailIdIsSet = false
    }
    if (!isDeleted(this) && !this.emailIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): EmailTrackingRefTrackedI {
    if (!this.emailIdApplyFilter(filter)) this.emailIdIsSet = false;

    return this;
  }
  emailIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      EmailTrackingRefMeta.emailId,
      EmailTrackingRefMeta,
      this.emailId,
      this,
    );
  }
  emailIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIdIsSet && this.emailIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.emailIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
